export const isMonitoringLink = (pathname: string) =>
    pathname.startsWith("/producer/mlink");
